import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import 'swiper/swiper.min.css';
import 'swiper/css/effect-fade';
import { useToggle } from 'ahooks';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { Autoplay, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Image } from '../common/components/image';
import { TextLoop } from '../common/components/text-loop';
import { useMobile } from '../common/hooks/use-mobile';
import { isClickable, transformFontsize, transformPageMargins } from '../common/utils';
import { useWrapStyle } from '../common/hooks/use-wrap-style';
import { useDesignContext } from '../design-provider';
var NoticeBar = function NoticeBar(props) {
  var behavior = props.behavior,
    bgColor = props.bgColor,
    fontWeight = props.fontWeight,
    image = props.image,
    interval = props.interval,
    textColor = props.textColor,
    titleSize = props.titleSize,
    notices = props.notices,
    bgSetting = props.bgSetting,
    bgPicture = props.bgPicture,
    pagePadding = props.pagePadding;
  var hasMultiItem = notices.length > 1;
  var _useState = useState(),
    swiper = _useState[0],
    setSwiper = _useState[1];
  var mobile = useMobile();
  var _useDesignContext = useDesignContext(),
    designOnLink = _useDesignContext.designOnLink;
  var _useToggle = useToggle(true),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    playing = _useToggle2[0],
    playActions = _useToggle2[1];
  function setAutoHeight(swiper) {
    if (behavior === 'top') {
      var resetSlidesHeight = function resetSlidesHeight(height) {
        // eslint-disable-next-line no-return-assign
        swiper.slides.forEach(function (slide) {
          return slide.style.height = height;
        });
        swiper.updateAutoHeight();
      };
      if (swiper.slides) {
        setTimeout(function () {
          var heights = swiper.slides.map(function (slide) {
            var _a;
            return (_a = slide.querySelector('.swiper-content')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
          });
          var maxHeight = "".concat(Math.max.apply(Math, _toConsumableArray(heights)), "px");
          resetSlidesHeight(maxHeight);
        }, 100);
      }
    }
  }
  useEffect(function () {
    if (swiper) setAutoHeight(swiper);
  }, [notices.map(function (notice) {
    return notice.title;
  }).join(), mobile]);
  var autoHeight = ['top', 'fade'].includes(behavior);
  var wrapStyle = useWrapStyle(bgSetting, bgPicture, bgColor);
  return _jsx("div", Object.assign({
    className: 'box-border overflow-hidden',
    style: Object.assign(Object.assign({}, wrapStyle), {
      paddingLeft: transformPageMargins(pagePadding, mobile),
      paddingRight: transformPageMargins(pagePadding, mobile)
    })
  }, {
    children: _jsx(Swiper, Object.assign({
      className: classNames('cq-mobile:h-10 cq-pc:h-15', {
        'cq-mobile:h-auto cq-pc:h-auto': autoHeight
      }),
      autoHeight: autoHeight,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: true,
      autoplay: {
        delay: interval
      },
      loop: hasMultiItem,
      direction: behavior === 'top' ? 'vertical' : 'horizontal',
      effect: behavior === 'fade' ? 'fade' : undefined,
      speed: 1000,
      modules: [Autoplay, EffectFade],
      onSwiper: setSwiper,
      onSlideChange: setAutoHeight,
      onSlidesLengthChange: setAutoHeight,
      onResize: setAutoHeight,
      onTransitionStart: function onTransitionStart() {
        return playActions.set(false);
      },
      onTransitionEnd: function onTransitionEnd() {
        return playActions.set(true);
      }
    }, {
      children: notices.map(function (notice) {
        return _jsx(SwiperSlide, Object.assign({
          style: Object.assign({
            fontWeight: fontWeight,
            color: textColor,
            fontSize: transformFontsize(titleSize, mobile),
            lineHeight: 'normal'
          }, wrapStyle)
        }, {
          children: _jsx("a", Object.assign({
            className: 'h-full flex items-center',
            href: designOnLink(notice.target)
          }, {
            children: _jsxs("div", Object.assign({
              className: classNames('swiper-content flex-1 flex items-center', {
                'cursor-pointer': isClickable(notice.target)
              })
            }, {
              children: [image === 'open' && _jsx(Image, {
                className: 'mr-2 w-10',
                src: notice.fileValue
              }), _jsx(TextLoop, Object.assign({
                className: 'flex-1',
                play: playing,
                duration: interval
              }, {
                children: notice.title
              }))]
            }))
          }))
        }), notice.id);
      })
    }), [behavior, interval].join(':'))
  }));
};
export default NoticeBar;